import { BrowserCache } from '@/utils/cache'
import { AgentsState, CachedAgentsState, toCachedAgentsState } from './agents'
import { CachedGlobalState, GlobalState, toCachedGlobalState } from './global'

export const RETIRED_BROWSER_CACHE_KEYS = [
  'account',
  'admin',
  'configAssistant',
  'embeddings',
  'factories',
  'mcp',
  'models',
  'pages',
  'pricing',
  'prompts',
  'providers',
  'scheduledRuns',
  'subscription',
  'videoProcessing',
  'voices',
  'workflows'
] as const

export interface InitialBrowserCacheState {
  global: Partial<CachedGlobalState>
  agents: Partial<CachedAgentsState>
}

export function initializeBrowserCache(cache: BrowserCache): InitialBrowserCacheState {
  RETIRED_BROWSER_CACHE_KEYS.forEach((key) => cache.remove(key))

  const legacyGlobal = cache.get<Partial<GlobalState>>('global')
  const legacyAgents = cache.get<Partial<AgentsState> & Partial<CachedAgentsState>>('agents')
  const global = toCachedGlobalState(legacyGlobal ?? {})
  const agents = toCachedAgentsState(legacyAgents ?? {})

  if (legacyGlobal) {
    cache.add('global', global)
  }
  if (legacyAgents) {
    cache.add('agents', agents)
  }

  return {
    global,
    agents
  }
}
